(function () {
  "use strict";

  var CFG = window.HM_MENU_ASSETS || {};
  var IMG = CFG.base || "assets/img/";
  var P = CFG.prefix || "";            /* tema: "hm-menu-" */
  var ORN = CFG.base ? (IMG + P + "orn-") : (IMG + "orn/");
  var YEMEK = CFG.base ? (IMG + P) : (IMG + "yemek/buyuk/");

  /* ---------- dil ---------- */

  var DILLER = ["tr", "en", "es", "zh"];
  var VARSAYILAN = "tr";
  var MAGAZA = ((window.HM && window.HM.locale) || document.documentElement.lang || "tr").toLowerCase().split("-")[0];

  function dilOku() {
    var q = (location.search.match(/[?&]lang=(tr|en|es|zh)/i) || [])[1];
    if (q) return q.toLowerCase();
    if (MAGAZA !== VARSAYILAN && DILLER.indexOf(MAGAZA) !== -1) return MAGAZA;
    try {
      var kayit = localStorage.getItem("hm-menu-lang");
      if (kayit && DILLER.indexOf(kayit) !== -1) return kayit;
    } catch (err) { /* ozel modda localStorage kapali olabilir */ }
    return VARSAYILAN;
  }

  var dil = dilOku();

  function t(v) {
    if (v === null || v === undefined) return "";
    if (typeof v === "string") return v;
    return v[dil] !== undefined && v[dil] !== "" ? v[dil] : (v.en || v.tr || "");
  }

  var UI = {
    coverTitle:  { tr: "MENÜ", en: "MENU", es: "MENÚ", zh: "菜单" },
    coverFoot:   { tr: "İstanbul — 1864", en: "Istanbul — since 1864", es: "Estambul — desde 1864", zh: "伊斯坦布尔 — 始于1864年" },
    backTitle:   { tr: "Afiyet Olsun", en: "Bon Appétit", es: "¡Buen provecho!", zh: "祝您用餐愉快" },
    backFoot:    { tr: "hafizmustafa.com", en: "hafizmustafa.com", es: "hafizmustafa.com", zh: "hafizmustafa.com" },
    tocKicker:   { tr: "Fihrist", en: "Index", es: "Índice", zh: "目录" },
    tocTitle:    { tr: "İÇİNDEKİLER", en: "CONTENTS", es: "CONTENIDO", zh: "目录" },
    tocHint:     { tr: "Bölüm adına dokunarak ilgili sayfaya gidebilirsiniz. Ürüne dokununca fotoğrafı sayfanın altında belirir.",
                   en: "Tap a chapter to jump to its page. Tap an item to see its photograph at the foot of the page.",
                   es: "Toca un capítulo para ir a su página. Toca un producto para ver su fotografía al pie de la página.",
                   zh: "点击章节名称即可跳转到对应页面。点击菜品，其照片会显示在页面底部。" },
    navIndex:    { tr: "Fihrist", en: "Index", es: "Índice", zh: "目录" },
    navPrev:     { tr: "Önceki sayfa", en: "Previous page", es: "Página anterior", zh: "上一页" },
    navNext:     { tr: "Sonraki sayfa", en: "Next page", es: "Página siguiente", zh: "下一页" },
    buyut:       { tr: "büyütmek için dokunun", en: "tap to enlarge", es: "toca para ampliar", zh: "点击放大" },
    lbClose:     { tr: "Kapat", en: "Close", es: "Cerrar", zh: "关闭" }
  };

  var FASIL = [
    { tr: "Birinci Fasıl", en: "Chapter One", es: "Capítulo primero", zh: "第一章" },
    { tr: "İkinci Fasıl", en: "Chapter Two", es: "Capítulo segundo", zh: "第二章" },
    { tr: "Üçüncü Fasıl", en: "Chapter Three", es: "Capítulo tercero", zh: "第三章" },
    { tr: "Dördüncü Fasıl", en: "Chapter Four", es: "Capítulo cuarto", zh: "第四章" },
    { tr: "Beşinci Fasıl", en: "Chapter Five", es: "Capítulo quinto", zh: "第五章" },
    { tr: "Altıncı Fasıl", en: "Chapter Six", es: "Capítulo sexto", zh: "第六章" },
    { tr: "Yedinci Fasıl", en: "Chapter Seven", es: "Capítulo séptimo", zh: "第七章" },
    { tr: "Sekizinci Fasıl", en: "Chapter Eight", es: "Capítulo octavo", zh: "第八章" },
    { tr: "Dokuzuncu Fasıl", en: "Chapter Nine", es: "Capítulo noveno", zh: "第九章" },
    { tr: "Onuncu Fasıl", en: "Chapter Ten", es: "Capítulo décimo", zh: "第十章" },
    { tr: "On Birinci Fasıl", en: "Chapter Eleven", es: "Capítulo undécimo", zh: "第十一章" },
    { tr: "On İkinci Fasıl", en: "Chapter Twelve", es: "Capítulo duodécimo", zh: "第十二章" },
    { tr: "On Üçüncü Fasıl", en: "Chapter Thirteen", es: "Capítulo decimotercero", zh: "第十三章" },
    { tr: "On Dördüncü Fasıl", en: "Chapter Fourteen", es: "Capítulo decimocuarto", zh: "第十四章" },
    { tr: "On Beşinci Fasıl", en: "Chapter Fifteen", es: "Capítulo decimoquinto", zh: "第十五章" },
    { tr: "On Altıncı Fasıl", en: "Chapter Sixteen", es: "Capítulo decimosexto", zh: "第十六章" },
    { tr: "On Yedinci Fasıl", en: "Chapter Seventeen", es: "Capítulo decimoséptimo", zh: "第十七章" },
    { tr: "On Sekizinci Fasıl", en: "Chapter Eighteen", es: "Capítulo decimoctavo", zh: "第十八章" },
    { tr: "On Dokuzuncu Fasıl", en: "Chapter Nineteen", es: "Capítulo decimonoveno", zh: "第十九章" },
    { tr: "Yirminci Fasıl", en: "Chapter Twenty", es: "Capítulo vigésimo", zh: "第二十章" }
  ];

  /* ---------- menu ---------- */

  var SECTIONS = (window.HM_MENU && window.HM_MENU.sections) || [];

  var bookEl = document.getElementById("book");
  var pageFlip = null;
  var sectionPageIndex = {};
  var pages = [];



  function el(tag, cls, html) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (html !== undefined) node.innerHTML = html;
    return node;
  }

  function metin(tag, cls, str) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    node.textContent = str;
    return node;
  }

  function ornamentRow() {
    return el("div", "orn", "&#10086;");
  }

  /* Safari/iOS: kutuphane touchstart'ta preventDefault cagirdigi icin click
     olusmayabiliyor; bu yuzden dokunma da ayrica dinleniyor. */
  function onTap(node, fn) {
    var sx = 0, sy = 0, moved = false;

    /* kutuphane mousedown/touchend ile sayfa ceviriyor; bu elemanlarda
       olayi durdurup yalnizca kendi islevimizin calismasini sagliyoruz */
    node.addEventListener("mousedown", function (ev) {
      ev.stopPropagation();
    });

    node.addEventListener("touchstart", function (ev) {
      var tc = ev.changedTouches[0];
      sx = tc.clientX;
      sy = tc.clientY;
      moved = false;
      ev.stopPropagation();
    }, { passive: true });

    node.addEventListener("touchmove", function (ev) {
      var tc = ev.changedTouches[0];
      if (Math.abs(tc.clientX - sx) > 12 || Math.abs(tc.clientY - sy) > 12) moved = true;
    }, { passive: true });

    node.addEventListener("touchend", function (ev) {
      if (moved) return;
      ev.preventDefault();
      ev.stopPropagation();
      fn(ev);
    });

    node.addEventListener("click", function (ev) {
      ev.stopPropagation();
      fn(ev);
    });
  }

  /* Suslemeler tek renk siluet oldugu icin gri maske olarak saklaniyor,
     rengi CSS veriyor: renkli PNG'ye gore cok daha hafif. */
  function ornMask(cls, dosya) {
    var d = el("div", cls);
    var u = "url('" + ORN + dosya + "')";
    d.style.webkitMaskImage = u;
    d.style.maskImage = u;
    return d;
  }

  function logoImg(cls, src) {
    var img = document.createElement("img");
    img.className = cls;
    img.src = src;
    img.alt = "";
    return img;
  }

  function titleOrn() {
    var d = el("div", "title-orn");
    d.appendChild(ornMask("title-orn-sekil", "divider2.png"));
    return d;
  }

  function addFrame(inner) {
    inner.appendChild(el("div", "frame"));
  }

  function makePage(cls, hard) {
    var page = el("div", "page " + cls);
    if (hard) page.setAttribute("data-density", "hard");
    var inner = el("div", "page-inner");
    if (cls.indexOf("paper") !== -1) inner.appendChild(el("div", "paper-bg"));
    page.appendChild(inner);
    return { page: page, inner: inner };
  }

  function coverCorners(inner) {
    inner.appendChild(el("div", "cover-frame"));
    inner.appendChild(ornMask("corner tl", "corner.png"));
    inner.appendChild(ornMask("corner tr", "corner.png"));
    inner.appendChild(ornMask("corner bl", "corner.png"));
    inner.appendChild(ornMask("corner br", "corner.png"));
  }

  function buildCover() {
    var p = makePage("cover", false);
    coverCorners(p.inner);
    var c = el("div", "content");
    c.appendChild(logoImg("cover-amblem", IMG + P + "logo-amblem.png"));
    c.appendChild(logoImg("cover-yazi", IMG + P + "logo-yazi.png"));
    c.appendChild(ornMask("cover-emblem", "tail.png"));
    c.appendChild(metin("div", "cover-title", t(UI.coverTitle)));
    c.appendChild(metin("div", "cover-foot", t(UI.coverFoot)));
    p.inner.appendChild(c);
    return p.page;
  }

  function buildBackCover() {
    var p = makePage("cover", false);
    coverCorners(p.inner);
    var c = el("div", "content");
    c.appendChild(logoImg("cover-amblem cover-amblem--kucuk", IMG + P + "logo-amblem.png"));
    c.appendChild(metin("div", "backcover-title", t(UI.backTitle)));
    c.appendChild(logoImg("cover-yazi cover-yazi--kucuk", IMG + P + "logo-yazi.png"));
    c.appendChild(metin("div", "cover-foot", t(UI.backFoot)));
    p.inner.appendChild(c);
    return p.page;
  }

  function buildToc(indexMap) {
    var p = makePage("paper", false);
    addFrame(p.inner);
    var c = el("div", "content");
    c.appendChild(metin("div", "fasil", t(UI.tocKicker)));
    c.appendChild(ornamentRow());
    c.appendChild(metin("div", "page-title", t(UI.tocTitle)));
    c.appendChild(titleOrn());

    var list = el("div", "toc-list");
    SECTIONS.forEach(function (s, i) {
      if (/\d$/.test(s.id)) return;   /* devam sayfalari fihristte listelenmez */
      var row = el("button", "toc-row");
      row.type = "button";
      row.appendChild(metin("span", "toc-name", t(s.title)));
      row.appendChild(el("span", "toc-dots"));
      row.appendChild(metin("span", "toc-page", String(i + 1)));
      onTap(row, function () {
        if (pageFlip) goToPage(indexMap[s.id]);
        if (history.replaceState) history.replaceState(null, "", "#" + s.id);
      });
      list.appendChild(row);
    });
    c.appendChild(list);
    c.appendChild(metin("div", "toc-hint", t(UI.tocHint)));
    p.inner.appendChild(c);
    return p.page;
  }

  function buildSectionPage(section, sira) {
    var p = makePage("paper", false);
    addFrame(p.inner);
    var c = el("div", "content");
    c.appendChild(metin("div", "fasil", t(FASIL[sira - 1])));
    c.appendChild(ornamentRow());

    var baslik = t(section.title).toUpperCase();
    var titleCls = baslik.length > 12 ? "page-title page-title--long" : "page-title";
    c.appendChild(metin("div", titleCls, baslik));
    c.appendChild(titleOrn());

    /* sayfanin alt boslugu: normalde gravur susu, bir yemege dokununca
       o yemegin eskitilmis fotografi burada belirir */
    var vitrin = el("div", "showcase");
    var susAlani = el("div", "showcase-orn");
    if (section.vign) susAlani.appendChild(ornMask("showcase-orn-sekil", section.vign));
    var fotoAlani = el("figure", "showcase-photo");
    var fotoImg = document.createElement("img");
    fotoImg.alt = "";
    fotoImg.decoding = "async";
    var fotoYazi = el("figcaption", "showcase-cap");
    var buyutNotu = el("div", "showcase-buyut");
    fotoAlani.appendChild(fotoImg);
    fotoAlani.appendChild(fotoYazi);
    fotoAlani.appendChild(buyutNotu);
    vitrin.appendChild(susAlani);
    vitrin.appendChild(fotoAlani);

    var secili = null;

    function vitrineKoy(d, dishEl) {
      if (secili === d) {
        vitrindenKaldir();
        return;
      }
      secili = d;
      fotoImg.src = YEMEK + d.img;
      fotoImg.alt = t(d.name);
      fotoYazi.textContent = t(d.name) + (t(d.price) ? "  ·  " + t(d.price) : "");
      buyutNotu.textContent = t(UI.buyut);
      vitrin.classList.add("acik");
      wrap.querySelectorAll(".dish.secili").forEach(function (n) {
        n.classList.remove("secili");
      });
      dishEl.classList.add("secili");
    }

    function vitrindenKaldir() {
      secili = null;
      vitrin.classList.remove("acik");
      wrap.querySelectorAll(".dish.secili").forEach(function (n) {
        n.classList.remove("secili");
      });
    }

    var wrap = el("div", "dishes");
    section.dishes.forEach(function (d) {
      var ad = t(d.name);
      var dish = el("div", "dish" + (d.img ? " fotografli" : ""));

      var body = el("div", "dish-body");
      var line = el("div", "dish-line");
      /* uzun adlar fiyati alt satira itmesin */
      var adCls = "dish-name" + (ad.length > 19 ? " dish-name--uzun" : "");
      line.appendChild(metin("span", adCls, ad));
      line.appendChild(el("span", "dish-dots"));
      if (t(d.price)) line.appendChild(metin("span", "dish-price", t(d.price)));
      body.appendChild(line);
      if (d.desc) body.appendChild(metin("div", "dish-desc", t(d.desc)));
      dish.appendChild(body);

      if (d.img) {
        onTap(dish, function () {
          vitrineKoy(d, dish);
        });
      }

      wrap.appendChild(dish);
    });
    c.appendChild(wrap);
    c.appendChild(vitrin);

    /* alttaki fotografa dokununca tam renkli hali acilir */
    onTap(fotoAlani, function () {
      if (secili) openLightbox(secili);
    });

    if (section.note) c.appendChild(metin("div", "page-note", t(section.note)));
    c.appendChild(el("div", "folio", "&mdash; " + sira + " &mdash;"));
    p.inner.appendChild(c);
    return p.page;
  }

  /* ---------- tam gorunum (popup) ---------- */

  var lb = document.getElementById("lightbox");
  var lbImg = document.getElementById("lightbox-img");
  var lbName = document.getElementById("lightbox-name");
  var lbPrice = document.getElementById("lightbox-price");
  var lbDesc = document.getElementById("lightbox-desc");

  function openLightbox(d) {
    lbImg.src = YEMEK + d.img;
    lbImg.alt = t(d.name);
    lbName.textContent = t(d.name);
    lbPrice.textContent = t(d.price);
    lbDesc.textContent = t(d.desc);
    lb.hidden = false;
  }

  function closeLightbox() {
    lb.hidden = true;
    lbImg.removeAttribute("src");
  }

  onTap(document.getElementById("lightbox-close"), closeLightbox);
  onTap(document.getElementById("lightbox-backdrop"), closeLightbox);
  document.addEventListener("keydown", function (ev) {
    if (ev.key === "Escape" && !lb.hidden) closeLightbox();
  });

  /* ---------- sayfalari kur ---------- */

  function buildPages() {
    var yeni = [];
    var harita = {};
    yeni.push(buildCover());
    yeni.push(null); // fihrist, indeksler bilindikten sonra yerlestirilir

    SECTIONS.forEach(function (s, i) {
      harita[s.id] = yeni.length;
      yeni.push(buildSectionPage(s, i + 1));
    });

    yeni.push(buildBackCover());
    yeni[1] = buildToc(harita);

    yeni.forEach(function (pg, i) {
      pg.setAttribute("data-side", i % 2 === 1 ? "left" : "right");
    });

    sectionPageIndex = harita;
    return yeni;
  }

  pages = buildPages();
  pages.forEach(function (pg) { bookEl.appendChild(pg); });

  pageFlip = new St.PageFlip(bookEl, {
    width: 500,
    height: 763,
    size: "stretch",
    minWidth: 300,
    maxWidth: 580,
    minHeight: 458,
    maxHeight: 885,
    maxShadowOpacity: 0.4,
    showCover: true,
    usePortrait: true,
    mobileScrollSupport: true,
    flippingTime: 800,
    showPageCorners: true
  });

  pageFlip.loadFromHTML(document.querySelectorAll("#book .page"));

  /* kapak tek basina gosterilirken kitabi ortala */
  var wrapEl = document.getElementById("book-wrap");

  function updateCoverShift(pageIndex) {
    document.documentElement.setAttribute("data-sayfa", String(pageIndex));
    wrapEl.classList.remove("at-front-cover", "at-back-cover");
    var onCover = pageIndex <= 0 || pageIndex >= pages.length - 1;
    wrapEl.classList.toggle("is-cover", onCover);

    var orientation = "";
    try { orientation = String(pageFlip.getOrientation()); } catch (err) { orientation = ""; }
    if (orientation === "portrait") return;
    if (pageIndex <= 0) wrapEl.classList.add("at-front-cover");
    else if (pageIndex >= pages.length - 1) wrapEl.classList.add("at-back-cover");
  }

  /* uzak sayfalara animasyonlu gecis guvenilir degil; yakinsa cevir, uzaksa atla */
  function goToPage(idx) {
    var simdi = 0;
    try { simdi = pageFlip.getCurrentPageIndex(); } catch (err) { simdi = 0; }
    if (Math.abs(idx - simdi) > 4) pageFlip.turnToPage(idx);
    else pageFlip.flip(idx);
  }

  /* adres satirindaki #bolum ile dogrudan o sayfaya ac */
  function gotoHash(animate) {
    var id = (location.hash || "").replace("#", "");
    if (!id || !(id in sectionPageIndex)) return -1;
    var idx = sectionPageIndex[id];
    if (animate) goToPage(idx);
    else pageFlip.turnToPage(idx);
    return idx;
  }

  var startIndex = gotoHash(false);
  window.addEventListener("hashchange", function () {
    var i = gotoHash(true);
    if (i >= 0) updateCoverShift(i);
  });

  pageFlip.on("flip", function (e) {
    updateCoverShift(e.data);
  });
  pageFlip.on("changeOrientation", function () {
    updateCoverShift(pageFlip.getCurrentPageIndex());
  });
  updateCoverShift(startIndex >= 0 ? startIndex : 0);

  /* ---------- navigasyon ---------- */

  var navPrev = document.getElementById("nav-prev");
  var navNext = document.getElementById("nav-next");
  var navIndex = document.getElementById("nav-index");

  onTap(navPrev, function () { pageFlip.flipPrev(); });
  onTap(navNext, function () { pageFlip.flipNext(); });
  onTap(navIndex, function () { goToPage(1); });

  document.addEventListener("keydown", function (ev) {
    if (ev.key === "ArrowLeft") pageFlip.flipPrev();
    if (ev.key === "ArrowRight") pageFlip.flipNext();
  });

  /* Kutuphane, dokunus 250 ms'den (swipeTimeout) kisa surerse sayfayi
     cevirmiyor; telefonda hizli dokunus bu yuzden ise yaramiyordu.
     Kisa dokunuslari burada karsiliyoruz (yemek/fihrist ogeleri kendi
     islevlerinde olayi durdurdugu icin buraya ulasmaz). */
  var dokunX = 0, dokunY = 0, dokunBas = 0, kaydi = false;

  bookEl.addEventListener("touchstart", function (ev) {
    var tc = ev.changedTouches[0];
    dokunX = tc.clientX;
    dokunY = tc.clientY;
    dokunBas = new Date().getTime();
    kaydi = false;
  }, { passive: true });

  bookEl.addEventListener("touchmove", function (ev) {
    var tc = ev.changedTouches[0];
    if (Math.abs(tc.clientX - dokunX) > 12 || Math.abs(tc.clientY - dokunY) > 12) kaydi = true;
  }, { passive: true });

  bookEl.addEventListener("touchend", function () {
    if (kaydi) return;
    if (new Date().getTime() - dokunBas >= 240) return; // uzun basisi kutuphane isler
    var r = bookEl.getBoundingClientRect();
    if (dokunX - r.left < r.width / 2) pageFlip.flipPrev();
    else pageFlip.flipNext();
  });

  /* ---------- dil secici ---------- */

  function arayuzuGuncelle() {
    document.documentElement.lang = dil;
    navIndex.textContent = t(UI.navIndex);
    navPrev.setAttribute("aria-label", t(UI.navPrev));
    navNext.setAttribute("aria-label", t(UI.navNext));
    document.getElementById("lightbox-close").setAttribute("aria-label", t(UI.lbClose));

    DILLER.forEach(function (kod) {
      var btn = document.getElementById("lang-" + kod);
      if (!btn) return;
      var secili = kod === dil;
      btn.classList.toggle("secili", secili);
      btn.setAttribute("aria-pressed", secili ? "true" : "false");
    });
  }

  function dilDegistir(yeni) {
    if (yeni === dil || DILLER.indexOf(yeni) === -1) return;
    dil = yeni;
    try { localStorage.setItem("hm-menu-lang", dil); } catch (err) { /* yoksay */ }

    var kalinan = 0;
    try { kalinan = pageFlip.getCurrentPageIndex(); } catch (err) { kalinan = 0; }

    /* kutuphane kendi kapsayicisini temizleyip yeni sayfalari yerlestirir;
       bookEl'e elle dokunmak yapisini bozuyor */
    pages = buildPages();
    pageFlip.updateFromHtml(pages);
    if (kalinan > 0) pageFlip.turnToPage(kalinan);

    arayuzuGuncelle();
    updateCoverShift(kalinan);
  }

  DILLER.forEach(function (kod) {
    var btn = document.getElementById("lang-" + kod);
    if (btn) onTap(btn, function () { dilDegistir(kod); });
  });

  arayuzuGuncelle();
})();
